module.exports = __webpack_public_path__ + "static/media/RO.dc184ea0.jpg";